import React from 'react';
import ProofOfTransferFunctional from './components/proof-of-transfer-functional';
import './proof-of-transfer.scss';

const ProofOfTranfer = () => {
	return <ProofOfTransferFunctional />;
};
export default ProofOfTranfer;
